import Vue from 'vue';
import VueI18n from 'vue-i18n';

import messages from '@/locales';

Vue.use(VueI18n);

/**
 * @type {VueI18n}
 */
export const vueI18n = new VueI18n({
  fallbackLocale: ["universal", "en"],
  silentFallbackWarn: true,
  messages,
});


export default vueI18n;
